/**
 * 展示上传弹窗，公共组件
 */
import Decorate from '@tencent/spaui-decorate'
import OperationBindDialog from 'biz-components/OperationBindDialog'
import OperationReplaceDialog from 'biz-components/OperationReplaceDialog'
import { OPERATION_DIALOG } from '../constants'

const dialogInstances = {
    [OPERATION_DIALOG.BIND]: new Decorate(OperationBindDialog),
    [OPERATION_DIALOG.REPLACE]: new Decorate(OperationReplaceDialog),
}

export const handleClose = type => {
    return () => {
        dialogInstances[type].setProps({
            show: false,
        })
    }
}

export const showOpDialog = (type, props) => {
    dialogInstances[type].setProps({
        show: true,
        onClose: handleClose(type),
        onCancel: handleClose(type),
        ...props,
        children: null,
    })
}
export default showOpDialog
